import { render, staticRenderFns } from "./PersonalPayPage.vue?vue&type=template&id=2fe9bee5&scoped=true&lang=pug&"
import script from "./PersonalPayPage.vue?vue&type=script&lang=js&"
export * from "./PersonalPayPage.vue?vue&type=script&lang=js&"
import style0 from "./PersonalPayPage.vue?vue&type=style&index=0&id=2fe9bee5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9bee5",
  null
  
)

export default component.exports